import PropTypes from 'prop-types';

export const formType = PropTypes.shape({
    raceDatetime: PropTypes.string,
    courseName: PropTypes.string,
    distanceYard: PropTypes.number,
    goingTypeServicesDesc: PropTypes.string,
    goingTypeCode: PropTypes.string,
    weightCarriedLbs: PropTypes.number,
    otherHorse: PropTypes.shape({
        styleName: PropTypes.string,
        weightCarriedLbs: PropTypes.number,
    }),
    oddsDesc: PropTypes.string,
    jockeyShortName: PropTypes.string,
    officialRatingRanOff: PropTypes.number,
    rpTopspeed: PropTypes.number,
    rpPostmark: PropTypes.number,
    rukReplayAvailable: PropTypes.bool,
});

export const figuresType = PropTypes.arrayOf(PropTypes.shape({
    raceTypeCode: PropTypes.string,
    formFigure: PropTypes.string,
}));

export const raceRecordsType = PropTypes.shape({
    jumpsFiguresCalculated: figuresType,
    flatFiguresCalculated: figuresType,
    lifetimeRecords: PropTypes.objectOf(PropTypes.shape({
        starts: PropTypes.number.isRequired,
        wins: PropTypes.number.isRequired,
        '2nds': PropTypes.number.isRequired,
        '3rds': PropTypes.number.isRequired,
        winnigs: PropTypes.number,
        earnings: PropTypes.number,
        'or+': PropTypes.number,
        bestTs: PropTypes.number,
        bestRpr: PropTypes.number,
    })),
});

export const myRatingsType = PropTypes.objectOf(PropTypes.number);



// WEBPACK FOOTER //
// ./src/js/horse/form/dataPropTypes.js